module.exports = __webpack_public_path__ + "static/media/seriousPersistentPain.aef418ec.mp3";